import React, { useState } from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, Check, Gift, Clock, Footprints, BarChart3, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const bonusDetails = [{
  number: 1,
  icon: Clock,
  image: 'https://cdn.magicpatterns.com/uploads/mhQAhHCYejj9arvCt9yGiz/bono_1.png',
  title: 'Modo Día Malo — Rescate de 6 Minutos',
  description: 'Hay días en los que la rodilla amanece más rígida, sensible o "cargada". Y ahí es donde la mayoría se pierde: o fuerza de más… o se frena por completo. Este bono te da un protocolo ultra corto (con semáforo) para esos días, sin improvisar.',
  includes: ['Rescate guiado de 6 minutos (paso a paso)', 'Reglas claras para ajustar sin miedo', 'Checklist imprimible en 1 página'],
  whyItMatters: 'Porque el plan no se rompe cuando el día viene malo.'
}, {
  number: 2,
  icon: Footprints,
  image: 'https://cdn.magicpatterns.com/uploads/qLUZaWpvh698A3bZYBrRZg/bono_2.png',
  title: 'Caminata Inteligente — Guía Anti-Inflamación (Regla 2–1–2)',
  description: 'Si caminar se convirtió en "hoy salgo… mañana pago", esto te va a dar mucha tranquilidad. Este bono te enseña a caminar con un sistema simple de bloques + pausas para que sumes constancia sin castigar la rodilla.',
  includes: ['La regla 2–1–2 (caminar / pausa / caminar)', 'Semáforo aplicado a la caminata (qué hacer en verde/amarillo/rojo)', 'Checklist de salida + plan de 14 días imprimible'],
  whyItMatters: 'Porque caminar es vida diaria… y necesitás una forma de hacerlo sin recaer.'
}, {
  number: 3,
  icon: BarChart3,
  image: 'https://cdn.magicpatterns.com/uploads/8okgTEkkLvTmk6zApAbUtb/bono_3.png',
  title: 'Control de Progreso — Tracker + Tests (Día 1 / 7 / 14)',
  description: 'Una de las razones por las que la gente abandona es simple: no ve progreso claro… y siente que está "intentando a ciegas". Este bono te da un sistema muy fácil para medir avances reales en 2 minutos por día.',
  includes: ['Tests simples en Día 1 / Día 7 / Día 14', 'Registro diario (semáforo + nivel + cómo amanecés)', 'Hoja semanal imprimible + regla "2 días verdes para subir"'],
  whyItMatters: 'Porque cuando ves progreso, seguís. Y cuando seguís, ganás.'
}];
export function ClosingCTA() {
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  return <Section background="warm" id="checkout" data-id="element-87">
      <FadeIn data-id="element-88">
        <div className="text-center max-w-2xl mx-auto" data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif" data-id="element-90">
            Empezá hoy mismo
          </h2>

          <p className="text-xl text-gray-700 mb-10 leading-relaxed" data-id="element-91">
            La pregunta no es si tu rodilla "algún día" va a mejorar. La
            pregunta es si vas a seguir negociando con ella salida por salida… o
            si vas a empezar a construir una rodilla más confiable con un plan
            que no te traicione.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-[#D8F3DC] mb-8" data-id="element-92">
            <div className="mb-6" data-id="element-93">
              <span className="inline-block bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-94">
                Oferta especial
              </span>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-95">
                <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-96">
                  $18.600
                </span>
              </div>
              <div className="text-5xl font-bold text-[#1B4332] mt-1" data-id="element-97">
                $9.300
                <span className="text-xl text-gray-400 font-normal ml-1" data-id="element-98">
                  ARS
                </span>
              </div>
              <p className="text-sm text-[#40916C] font-semibold mt-2" data-id="element-99">
                50% de descuento — por tiempo limitado
              </p>
            </div>

            <div className="border-t border-gray-100 pt-6 mb-6" data-id="element-100">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-101">
                Tu compra incluye
              </p>

              <div className="flex items-center gap-3 mb-3 text-left" data-id="element-102">
                <Check className="w-5 h-5 text-[#40916C] flex-shrink-0" data-id="element-103" />
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-104">
                  PDF completo "Rodilla Sin Miedo" + Plan de 14 días
                </span>
              </div>
              <div className="flex items-center gap-3 mb-3 text-left" data-id="element-105">
                <Check className="w-5 h-5 text-[#40916C] flex-shrink-0" data-id="element-106" />
                <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-107">
                  Checklist imprimible + Módulo 60+/Artrosis
                </span>
              </div>

              <div className="mt-4 mb-2 flex items-center justify-center gap-2" data-id="element-108">
                <Gift className="w-4 h-4 text-[#1B4332]" data-id="element-109" />
                <span className="text-xs font-bold text-[#1B4332] uppercase tracking-widest" data-id="element-110">
                  3 Bonos Gratis
                </span>
                <span className="text-xs text-gray-400 line-through ml-1" data-id="element-111">
                  $47.000 ARS
                </span>
                <span className="bg-[#D8F3DC] text-[#1B4332] text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-112">
                  $0
                </span>
              </div>

              <div className="space-y-2.5 mt-3" data-id="element-113">
                <div className="flex items-start gap-3 text-left bg-[#FAFAF8] rounded-lg p-3" data-id="element-114">
                  <Clock className="w-4 h-4 text-[#40916C] mt-0.5 flex-shrink-0" data-id="element-115" />
                  <div data-id="element-116">
                    <span className="text-sm font-semibold text-[#1A1A1A]" data-id="element-117">
                      Bono #1:
                    </span>
                    <span className="text-sm text-gray-600 ml-1" data-id="element-118">
                      Modo Día Malo — Rescate de 6 Minutos
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-left bg-[#FAFAF8] rounded-lg p-3" data-id="element-119">
                  <Footprints className="w-4 h-4 text-[#40916C] mt-0.5 flex-shrink-0" data-id="element-120" />
                  <div data-id="element-121">
                    <span className="text-sm font-semibold text-[#1A1A1A]" data-id="element-122">
                      Bono #2:
                    </span>
                    <span className="text-sm text-gray-600 ml-1" data-id="element-123">
                      Caminata Inteligente — Guía Anti-Inflamación
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-left bg-[#FAFAF8] rounded-lg p-3" data-id="element-124">
                  <BarChart3 className="w-4 h-4 text-[#40916C] mt-0.5 flex-shrink-0" data-id="element-125" />
                  <div data-id="element-126">
                    <span className="text-sm font-semibold text-[#1A1A1A]" data-id="element-127">
                      Bono #3:
                    </span>
                    <span className="text-sm text-gray-600 ml-1" data-id="element-128">
                      Control de Progreso — Tracker + Tests
                    </span>
                  </div>
                </div>
              </div>

              <button onClick={() => setShowBonusDetails(!showBonusDetails)} className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1B4332] hover:text-[#2D6A4F] transition-colors focus:outline-none" data-id="element-129">
                {showBonusDetails ? 'Ocultar detalle' : 'Leer más sobre los bonos'}
                <motion.span animate={{
                rotate: showBonusDetails ? 180 : 0
              }} transition={{
                duration: 0.25
              }} className="inline-flex" data-id="element-130">
                  <ChevronDown className="w-4 h-4" data-id="element-131" />
                </motion.span>
              </button>

              <AnimatePresence data-id="element-132">
                {showBonusDetails && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-133">
                    <div className="mt-5 space-y-6" data-id="element-134">
                      {bonusDetails.map(bonus => <div key={bonus.number} className="bg-[#FAFAF8] rounded-xl p-5 text-left border border-gray-100" data-id="element-135">
                          <div className="flex items-start gap-4 mb-4" data-id="element-136">
                            <img src={bonus.image} alt={bonus.title} className="w-20 h-auto object-contain flex-shrink-0 rounded-lg drop-shadow-md" data-id="element-137" />
                            <div data-id="element-138">
                              <span className="inline-flex items-center gap-1 bg-[#D8F3DC] text-[#1B4332] text-xs font-bold uppercase tracking-wider px-2 py-1 rounded-full mb-2" data-id="element-139">
                                <Check className="w-3 h-3" data-id="element-140" />
                                Bono #{bonus.number} — Gratis
                              </span>
                              <h4 className="text-base font-bold text-[#111] font-serif" data-id="element-141">
                                {bonus.title}
                              </h4>
                            </div>
                          </div>

                          <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-142">
                            {bonus.description}
                          </p>

                          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-143">
                            Incluye:
                          </p>
                          <ul className="space-y-1.5 mb-4" data-id="element-144">
                            {bonus.includes.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-145">
                                <Check className="w-3.5 h-3.5 text-[#40916C] mt-0.5 flex-shrink-0" data-id="element-146" />
                                <span className="text-sm text-gray-700" data-id="element-147">
                                  {item}
                                </span>
                              </li>)}
                          </ul>

                          <div className="bg-white rounded-lg p-3 border-l-3 border-[#40916C]" style={{
                      borderLeftWidth: '3px',
                      borderLeftColor: '#40916C'
                    }} data-id="element-148">
                            <p className="text-xs" data-id="element-149">
                              <span className="font-semibold text-[#1B4332]" data-id="element-150">
                                Por qué importa:{' '}
                              </span>
                              <span className="text-gray-600 italic" data-id="element-151">
                                {bonus.whyItMatters}
                              </span>
                            </p>
                          </div>
                        </div>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <Button size="lg" className="w-full md:w-auto min-w-[280px] mb-4" data-id="element-152">
              Accedé ahora a Rodilla Sin Miedo
            </Button>

            <div className="flex flex-col gap-2 text-sm text-gray-500 mt-4" data-id="element-153">
              <div className="flex items-center justify-center gap-2" data-id="element-154">
                <Lock className="h-4 w-4" data-id="element-155" />
                <span data-id="element-156">Pago 100% Seguro</span>
              </div>
              <p data-id="element-157">PDF descargable al instante • Rutina 10–12 min</p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}